<template>
  <div class="middle-content">
    <div class="map-blur" id="map-blur">
      <div class="map-blur-text">
        <h2 class>Redirecionando</h2>
        <p>Você está sendo redirecionado...</p>
      </div>
      <div class="map-blur-image"></div>
    </div>
    <div class="map-container on-left" id="map-container"></div>
  </div>
</template>

<script>
import { i18nMixin } from '../../modules/shared/mixins/i18n.mixin';
import { UserManager, WebStorageStateStore, User } from 'oidc-client';
import AuthService from '../../services/authservice';

const mgr = new UserManager({ response_mode: 'query', userStore: new WebStorageStateStore({}) });

export default {
  name: 'Redirect',

  props: {},

  data() {},

  mixins: [i18nMixin],

  methods: {},

  mounted() {
    mgr.signinPopupCallback();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/callback/popup.vue